// src/lib/hooks/admin/useUsageTenants.ts
import { useQuery } from '@tanstack/react-query';
import { fetchUsageTenants } from '@/lib/api/admin';
import type { TenantUsageRow } from '@/types/admin';
import { usageKeys } from './useUsageOverview';

export const useUsageTenants = (filters: { from: string; to: string }, enabled = true) => {
  return useQuery<TenantUsageRow[]>({
    queryKey: usageKeys.tenants(filters),
    queryFn: () => fetchUsageTenants(filters),
    enabled,
    staleTime: 60 * 1000,
  });
};
